export default __webpack_public_path__ + "static/m-customers-b92485594c3c5960040f0baf8e61c3dd.jpg";